module.exports = __webpack_public_path__ + "img/empty.d8965486.png";